<template>
  <fragment>
    <header class="header">
      <div class="header__inner">
        <div class="header__logo">
          <router-link :to="logoTo"><img :src="logoUrl" alt="" /></router-link>
        </div>
        <div class="header__menu">
          <el-badge v-if="!hasCorporateFlag" :value="count" class="item mr-4" :max="99" :hidden="!count">
            <el-button type="text" @click="Utils.helper.redirect({ name: 'EC_LINE003' })">
              <inline-svg :src="cartUrl" />
            </el-button>
          </el-badge>
          <el-button type="text" @click="onOpenMenu">
            <inline-svg :src="menuUrl" />
          </el-button>
        </div>
      </div>
    </header>
    <the-menu :visible.sync="menuVisible"></the-menu>
  </fragment>
</template>

<script>
import TheMenu from '@/components/TheMenu.vue'

export default {
  components: {
    TheMenu,
  },
  data() {
    return {
      menuVisible: false,
      publicPath: process.env.BASE_URL,
    }
  },
  watch: {
    menuVisible(val) {
      const body = document.body
      body.style.overflow = val ? 'hidden' : 'auto'
    },
  },
  computed: {
    count() {
      return this.$store.getters['cart/totalItem']
    },
    logoUrl() {
      return `${this.Constants.SHOP_CONFIG.LOGO_URL}`
    },
    cartUrl() {
      return `${this.Constants.SHOP_CONFIG.CART_URL}`
    },
    menuUrl() {
      return `${this.Constants.SHOP_CONFIG.MENU_URL}`
    },
    hasCorporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    logoTo() {
      return this.hasCorporateFlag ? this.$routePage.EC_LINE009 : this.$routePage.EC_LINE001
    },
  },
  methods: {
    onOpenMenu() {
      this.menuVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/the-header.scss';
</style>
